module.exports = __webpack_public_path__ + "static/img/icon_logo.f532bfd3.png";